import React from "react";

export default class InputText extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      txt: "",
    };

    this.updateText = this.updateText.bind(this);
  }

  validateText(txt) {
    if (!this.props.regex && this.props.required) {
      return txt.length > 0;
    }
    if (typeof this.props.regex === "string") {
      var re = new RegExp(this.props.regex);
    } else {
      var re = this.props.regex;
    }
    return re.test(txt);
  }

  updateText(event) {
    var txt = event.target.value;
    this.setState({ txt: txt });
    this.props.handleChange(txt);
  }
  render() {
    var messageWarning, cl, message;
    if (this.state.txt.length > 0) {
      if (this.validateText(this.state.txt)) {
        cl = "";
        message = "";
      } else {
        cl = "error";
        message = this.props.message;
      }
      if (message.length > 0) {
        messageWarning = (
          <div className="alert alert-danger message">
            <div>{message}</div>
          </div>
        );
      } else {
        messageWarning = "";
      }
    }
    return (
      <div>
        <div className="inputForm">
          <input
            onBlur={this.updateText}
            className={"o-input " + cl + " " + this.props.cl}
            placeholder={this.props.placeholder}
            name={this.props.name}
            type={this.props.type}
            ref={this.props.reference}
            required={this.props.required}
          />
        </div>
        {messageWarning}
      </div>
    );
  }
}

InputText.propTypes = {
  type: React.PropTypes.string,
  message: React.PropTypes.string,
  handleChange: React.PropTypes.func,
  regex: React.PropTypes.string,
  required: React.PropTypes.bool,
};

InputText.defaultProps = {
  type: "text",
  message: "",
  handleChange: function() {
    return null;
  },
  regex: "(.*)",
  required: false,
};
